import React, { useMemo, useState } from 'react';

import { debounce } from 'lodash-es';
import { useQueryParam } from 'react-resource-router';

import Filter from '../components/filter';

export const FILTER_DEBOUNCE_INTERVAL = 250;

const StatefulWorkspaceProjectsFilter = (): JSX.Element => {
  const [isPrivate, setIsPrivate] = useQueryParam('is_private');
  const [searchQuery, setSearchQuery] = useQueryParam('query');
  const [search, setSearch] = useState(searchQuery);

  const debounceSearch = useMemo(
    () => debounce(setSearchQuery, FILTER_DEBOUNCE_INTERVAL),
    [setSearchQuery]
  );

  const onChangeIsPrivate = (isPrivateParam: string | undefined) => {
    setIsPrivate(isPrivateParam);
  };

  const onChangeSearch = (s: string) => {
    debounceSearch(s || undefined);
    setSearch(s);
  };

  return (
    <Filter
      isPrivate={isPrivate}
      search={search}
      onChangeIsPrivate={onChangeIsPrivate}
      onChangeSearch={onChangeSearch}
    />
  );
};

export default StatefulWorkspaceProjectsFilter;
